import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CustomTextField = ({
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  placeholder,
  type = "text",
  startIcon,
  endIcon, // optional icon component to render at the end
  InputProps: inputProps = {},
  ...rest
}) => {
  const theme = useTheme();

  return (
    <TextField
      fullWidth
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      error={Boolean(error)}
      helperText={helperText}
      placeholder={placeholder}
      type={type}
      InputProps={{
        ...inputProps,
        endAdornment: endIcon ? (
          <InputAdornment position="end">
            {endIcon}
          </InputAdornment>
        ) : inputProps.endAdornment,
        startAdornment: startIcon ? (
          <InputAdornment position="start" sx={{ mr: 0 }}>
            {startIcon}
          </InputAdornment>
        ) : inputProps.startAdornment,
        sx: {
          '& .MuiInputBase-input': {
            padding: '12px',
          },
          '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0,
          },
          '& input[type=number]': {
            '-moz-appearance': 'textfield',
          },
          borderRadius: theme.formFileds.borderRadius,
          fontSize: '14px',
          ...inputProps.sx,
        },
      }}
      sx={{
        // height: theme.formFileds.height
      }}
      {...rest}
    />
  );
};

export default CustomTextField;
